// extracted by mini-css-extract-plugin
export var attachmentContainer = "_iz-0";
export var fileList = "_iz-2";
export var removeFileButton = "_iz-1";